import { render, staticRenderFns } from "./ReservationSettings.vue?vue&type=template&id=5a4e828c&scoped=true&lang=pug"
import script from "./ReservationSettings.vue?vue&type=script&lang=ts"
export * from "./ReservationSettings.vue?vue&type=script&lang=ts"
import style0 from "./ReservationSettings.vue?vue&type=style&index=0&id=5a4e828c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e828c",
  null
  
)

export default component.exports